"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const AssetRegulation_1 = require("./AssetRegulation");
const CreativeFormat_1 = require("./CreativeFormat");
const DesignInspirationCategory_1 = require("./DesignInspirationCategory");
const DynamicSchemaDefinition_1 = require("./DynamicSchemaDefinition");
const MatchingFormatGroup_1 = require("./MatchingFormatGroup");
const Pricing_1 = require("./Pricing");
class ProjectType {
    constructor({ id, key, published, title, description, createdAt, displayPriority, popularity, thumbnailImageUrl, sampleVideoUrl, expectedDeliveryPeriod, outputSpecification, regulation, creativeBriefDefinition, supportingCreativeFormatNetworks, version, assetRegulation, minConceptCount, maxConceptCount, designInspirationCategories, pricingMerchandiseOptions, assetCategoryDefinition, matchingFormatGroup, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            published: this.published,
            title: this.title,
            description: this.description,
            createdAt: this.createdAt && this.createdAt.toISO(),
            displayPriority: this.displayPriority,
            popularity: this.popularity,
            thumbnailImageUrl: this.thumbnailImageUrl,
            sampleVideoUrl: this.sampleVideoUrl,
            expectedDeliveryPeriod: this.expectedDeliveryPeriod,
            outputSpecification: this.outputSpecification,
            regulation: this.regulation,
            creativeBriefDefinition: this.creativeBriefDefinition && this.creativeBriefDefinition.toJSON(),
            supportingCreativeFormatNetworks: this.supportingCreativeFormatNetworks && this.supportingCreativeFormatNetworks.toJSON(),
            version: this.version,
            assetRegulation: this.assetRegulation && this.assetRegulation.toJSON(),
            minConceptCount: this.minConceptCount,
            maxConceptCount: this.maxConceptCount,
            designInspiration: this.designInspirationCategories && this.designInspirationCategories.toJSON(),
            pricingMerchandiseOptions: this.pricingMerchandiseOptions,
            assetCategoryDefinition: this.assetCategoryDefinition && this.assetCategoryDefinition.toJSON(),
            matchingFormatGroup: this.matchingFormatGroup && this.matchingFormatGroup.toJSON(),
        });
        this.id = id;
        this.key = key;
        this.published = published;
        this.title = title;
        this.description = description;
        this.createdAt = createdAt;
        this.displayPriority = displayPriority;
        this.popularity = popularity;
        this.thumbnailImageUrl = thumbnailImageUrl;
        this.sampleVideoUrl = sampleVideoUrl;
        this.expectedDeliveryPeriod = expectedDeliveryPeriod;
        this.outputSpecification = outputSpecification;
        this.regulation = regulation;
        this.creativeBriefDefinition = creativeBriefDefinition;
        this.supportingCreativeFormatNetworks = supportingCreativeFormatNetworks;
        this.version = version;
        this.assetRegulation = assetRegulation;
        this.minConceptCount = minConceptCount;
        this.maxConceptCount = maxConceptCount;
        this.designInspirationCategories = designInspirationCategories;
        this.pricingMerchandiseOptions = pricingMerchandiseOptions;
        this.assetCategoryDefinition = assetCategoryDefinition;
        this.matchingFormatGroup = matchingFormatGroup;
    }
}
ProjectType.fromJSON = (json) => {
    const { id, key, published, title, description, createdAt, displayPriority, popularity, thumbnailImageUrl, sampleVideoUrl, expectedDeliveryPeriod, outputSpecification, regulation, creativeBriefDefinition, supportingCreativeFormatNetworks, version, assetRegulation, minConceptCount, maxConceptCount, designInspirationCategories, pricingMerchandiseOptions, assetCategoryDefinition, matchingFormatGroup, } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (key !== undefined && typeof key !== 'string')
        throw new Error('.key must be a string');
    if (published !== undefined && typeof published !== 'boolean')
        throw new Error('.published must be a boolean');
    if (title !== undefined && typeof title !== 'string')
        throw new Error('.title must be a string');
    if (description !== undefined && typeof description !== 'string')
        throw new Error('.description must be a string');
    if (displayPriority !== undefined && typeof displayPriority !== 'number')
        throw new Error('.displayPriority must be a number');
    if (popularity !== undefined && typeof popularity !== 'number')
        throw new Error('.popularity must be a number');
    if (thumbnailImageUrl !== undefined && typeof thumbnailImageUrl !== 'string')
        throw new Error('.thumbnailImageUrl must be a string');
    if (sampleVideoUrl !== undefined && sampleVideoUrl !== null && typeof sampleVideoUrl !== 'string')
        throw new Error('.sampleVideoUrl must be null or a string');
    if (expectedDeliveryPeriod !== undefined && typeof expectedDeliveryPeriod !== 'string')
        throw new Error('.expectedDeliveryPeriod must be a string');
    if (outputSpecification !== undefined && typeof outputSpecification !== 'string')
        throw new Error('.outputSpecification must be a string');
    if (regulation !== undefined && typeof regulation !== 'string')
        throw new Error('.regulation must be a string');
    if (supportingCreativeFormatNetworks !== undefined && !Array.isArray(supportingCreativeFormatNetworks))
        throw new Error('.supportingCreativeFormatNetworks must be an array');
    if (version !== undefined && typeof version !== 'number')
        throw new Error('.version must be a number');
    if (minConceptCount !== undefined && typeof minConceptCount !== 'number')
        throw new Error('.minConceptCount must be a number');
    if (maxConceptCount !== undefined && typeof maxConceptCount !== 'number')
        throw new Error('.maxConceptCount must be a number');
    if (designInspirationCategories !== undefined && !Array.isArray(designInspirationCategories))
        throw new Error('.designInspirationCategories must be an array');
    const _createdAt = createdAt ? luxon_1.DateTime.fromISO(createdAt) : undefined;
    const _creativeBriefDefinition = creativeBriefDefinition
        ? DynamicSchemaDefinition_1.default.fromJSON(creativeBriefDefinition)
        : undefined;
    const _supportingCreativeFormatNetworks = supportingCreativeFormatNetworks
        ? immutable_1.List(supportingCreativeFormatNetworks).map(item => CreativeFormat_1.SupportingCreativeFormatNetwork.fromJSON(item))
        : undefined;
    const _assetRegulation = assetRegulation ? AssetRegulation_1.default.fromJSON(assetRegulation) : undefined;
    const _designInspirationCategories = designInspirationCategories
        ? immutable_1.List(designInspirationCategories).map(item => DesignInspirationCategory_1.default.fromJSON(item))
        : undefined;
    const _pricingMerchandiseOptions = pricingMerchandiseOptions
        ? pricingMerchandiseOptions.map((_pricingMerchandiseOption) => Pricing_1.PricingMerchandiseOption.fromJSON(_pricingMerchandiseOption))
        : undefined;
    const _assetCategoryDefinition = assetCategoryDefinition
        ? DynamicSchemaDefinition_1.default.fromJSON(assetCategoryDefinition)
        : undefined;
    const _matchingFormatGroup = matchingFormatGroup ? MatchingFormatGroup_1.default.fromJSON(matchingFormatGroup) : undefined;
    return new ProjectType({
        id,
        key,
        published,
        title,
        description,
        createdAt: _createdAt,
        displayPriority,
        popularity,
        thumbnailImageUrl,
        sampleVideoUrl,
        expectedDeliveryPeriod,
        outputSpecification,
        regulation,
        creativeBriefDefinition: _creativeBriefDefinition,
        supportingCreativeFormatNetworks: _supportingCreativeFormatNetworks,
        version,
        assetRegulation: _assetRegulation,
        minConceptCount,
        maxConceptCount,
        designInspirationCategories: _designInspirationCategories,
        pricingMerchandiseOptions: _pricingMerchandiseOptions,
        assetCategoryDefinition: _assetCategoryDefinition,
        matchingFormatGroup: _matchingFormatGroup,
    });
};
exports.default = ProjectType;
